import React, { useEffect } from 'react';
import { Location, useLocation, useParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { MaterialRenderer } from '../../components/MaterialRenderer/MaterialRenderer';
import { LearningPathHeader } from '../../components/LearningPathHeader/LearningPathHeader';
import { LandingPage } from '../../components/LandingPage/LandingPage';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { RequestType, ActionType } from '../../global-interface';
import { SlLEContext } from '../../global-constants';

import s from './LearningPathContainer.scss';
import { Container, AuthService } from '../../../../symphony';

export function LearningPathContainer(): JSX.Element {
	useStyles(s);
	const { pathAlias } = useParams();

	const location: Location = useLocation();

	const { learningPath$: learningPath, loading$: loading } = useContainerData(
		SlLEContext,
		SlDataService,
		['learningPath$', 'loading$'],
	);

	const authService = Container.take('global', AuthService);

	useEffect(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: ActionType.OnLearningPathContainerMount,
			requestType: RequestType.Parallel,
			data: {
				alias: pathAlias,
				location,
			},
		});
	}, []);

	if (!authService.isLoggedIn()) {
		return <LandingPage alias={pathAlias} />;
	}

	return learningPath && !loading?.courseSkeleton ? (
		<div className="le-learning-path-container">
			<LearningPathHeader alias={pathAlias} />
			{learningPath.units.map((unit, i) => (
				<MaterialRenderer
					materialInfo={unit.courseSubtree.materialInfo}
					isExpanded
					hideCertificate={i < learningPath.units.length - 1}
					key={unit.alias}
				>
					{unit.courseSubtree.children}
				</MaterialRenderer>
			))}
		</div>
	) : null;
}
